import Config from '../../../static/config'
// 设置cookie
export function setCookie (name, value, days) {
  let sCookie = name + '=' + encodeURIComponent(value)
  if (days) {
    let exDate = new Date()
    exDate.setTime(exDate.getTime() + 24 * 60 * 60 * 1000 * days) // 保存天数
    sCookie += '; expires=' + exDate.toGMTString()
  }
  sCookie += '; path=/'
  sCookie += '; domain=' + Config.DOMAIN
  document.cookie = sCookie
}

// 获取cookie
export function getCookie (name) {
  let res = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  console.log('=== 获取cookie', decodeURIComponent(res[2]))
  return res ? decodeURIComponent(res[2]) : null
}

// 清除cookie
export function clearCookie (name) {
  setCookie(name, '', -1)
}

export function clearAllCookie () {
  let aCookie = document.cookie.split('; ')
  for (let i = 0; i < aCookie.length; i++) {
    let aCrumb = aCookie[i].split('=')
    if (aCrumb[0] !== 'loginName' && aCrumb[0] !== 'loginPwd') clearCookie(aCrumb[0])
  }
  window.location.href = home
}

export function goToHome () {
  window.location.href = home
}

export const home = Config.HOMEPAGE



// WEBPACK FOOTER //
// ./src/common/js/cookie.js